import { createEvent, restore, sample } from 'effector'
import { Permission, PermissionEditItem } from './types'
import { fx } from '../../../../libs'
import { $params } from '../../../../features/router'

export const submitEditPermission = createEvent<PermissionEditItem>()

export const setPermission = createEvent<Permission>()

export const permissionMounted = createEvent()

export const permissionRoleMounted = createEvent()

export const attachRoleMounted = createEvent<{ id: string; role: string }>()

export const detachRoleMounted = createEvent<{ id: string; role: string }>()

export const closeModal = createEvent()

export const editPermission = fx<Omit<PermissionEditItem, 'id'>, void>({
  method: 'PUT',
  url: '/permission/{permissionId}',
})

export const attachRole = fx<{ role: string }, void>({
  method: 'POST',
  url: '/permission/{permissionId}/attach_role',
})

export const detachRole = fx<{ role: string }, void>({
  method: 'POST',
  url: '/permission/{permissionId}/detach_role',
})

export const getPermission = fx<void, Permission>({
  method: 'GET',
  url: '/permission/{permissionId}',
})

export const getPermissionRole = fx<void, any>({
  method: 'GET',
  url: '/permission/by_role/{permissionId}',
})

export const $permission = restore(setPermission, {
  id: '',
  name: '',
  description: '',
  roles: [],
  extraUsers: [],
})

export const $permissionRole = restore<any>(
  getPermissionRole.doneData.map((a) => a.body.items),
  [],
)

sample({
  clock: submitEditPermission,
  fn: (permission) => {
    const { id, ...rest } = permission
    return {
      url: `/permission/${id}`,
      body: { ...rest },
    }
  },
  target: editPermission,
})

sample({
  clock: permissionMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.permissionID
    }
    return {
      url: `/permission/${id}`,
      query: {
        populate: JSON.stringify([
          'Permission.roles',
          'Role.description',
          'Permission.extraUsers',
          'User.username',
          'User.email',
          'User.firstName',
          'User.lastName',
        ]),
      },
    }
  },
  target: getPermission,
})

sample({
  clock: permissionRoleMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.permissionID
    }
    return {
      url: `/permission/by_role/${id}`,
    }
  },
  target: getPermissionRole,
})

sample({
  clock: attachRoleMounted,
  fn: (permission) => {
    const { id, ...rest } = permission
    return {
      url: `/permission/${id}/attach_role`,
      body: { ...rest },
    }
  },
  target: attachRole,
})

sample({
  clock: detachRoleMounted,
  fn: (permission) => {
    const { id, ...rest } = permission
    return {
      url: `/permission/${id}/detach_role`,
      body: { ...rest },
    }
  },
  target: detachRole,
})

sample({
  clock: getPermission.doneData,
  fn: (doneData) => doneData.body,
  target: setPermission,
})

export const $isSuccessEdit = restore(
  editPermission.doneData.map(() => true),
  false,
).reset(closeModal)

sample({
  clock: [attachRole.doneData, detachRole.doneData],
  fn: () => {},
  target: permissionMounted,
})
